class GoogleAnalytics {
	pageview(path) {
		if (!window.gtag) return;
		if (!window.GLOBAL_GA_KEY) return;
		window.gtag('config', window.GLOBAL_GA_KEY, {'page_path': path});
	}

	send_event(event_name, event_parameters) {
		if (!window.gtag) return;
		window.gtag('event', event_name, event_parameters);
	}

	game_impression(game_id) {
		this.send_event("Impression", {
			event_category: "GameLoad",
			event_label: "g"+game_id,
			non_interaction: true,
		});
	}

	click_on_unga_aktiesparare() {
		this.send_event("click", {
			event_category: "unga",
			event_label: "ref",
		});
		return true;
	}

	click_on_SDU() {
		this.send_event("click", {
			event_category: "SDU",
			event_label: "ref",
		});
		return true;
	}

	signup(method) {
		this.send_event('sign_up', {'method': method});
	}

	adwords_conversion(label) {
		if (!window.GLOBAL_AW_KEY || !window.GLOBAL_AW_LABELS || !window.GLOBAL_AW_LABELS[label]) return;
		const send_to = window.GLOBAL_AW_KEY + '/' + window.GLOBAL_AW_LABELS[label];
		this.send_event("conversion", {'send_to': send_to});
	}
}

export default new GoogleAnalytics();



// WEBPACK FOOTER //
// ./src/GoogleAnalytics.js